(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const updateTimer = (root) => {
    const endSeconds = Number(root.dataset.urgencyEnd || 0);
    if (!endSeconds) return;

    const remaining = (endSeconds * 1000) - Date.now();
    if (remaining <= 0) {
      root.dataset.urgencyEnded = 'true';
      root.querySelectorAll('[data-urgency-days], [data-urgency-hours], [data-urgency-minutes], [data-urgency-seconds]').forEach((item) => {
        item.textContent = '00';
      });
      const compactEl = root.querySelector('[data-urgency-compact]');
      if (compactEl) compactEl.textContent = 'Drop ended';
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const daysEl = root.querySelector('[data-urgency-days]');
    const hoursEl = root.querySelector('[data-urgency-hours]');
    const minutesEl = root.querySelector('[data-urgency-minutes]');
    const secondsEl = root.querySelector('[data-urgency-seconds]');

    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);

    const compactEl = root.querySelector('[data-urgency-compact]');
    if (compactEl) {
      compactEl.textContent = days > 0 ? days + 'd ' + pad(hours) + 'h left' : pad(hours) + 'h ' + pad(minutes) + 'm left';
    }
  };

  const initProductUrgency = () => {
    const timers = document.querySelectorAll('[data-product-urgency][data-urgency-end]:not([data-urgency-ready])');
    timers.forEach((root) => {
      root.dataset.urgencyReady = 'true';
      updateTimer(root);
      setInterval(() => updateTimer(root), 1000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductUrgency);
  } else {
    initProductUrgency();
  }

  document.addEventListener('shopify:section:load', initProductUrgency);
})();
